/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Presence_S3Inputs */

const en_tut_presence_s3 = /** @type {(inputs: Tut_Presence_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open **Pengaturan…** to set your working days and hours and your timezone — WIB, WITA, or WIT. Outside those hours your status reads as off-hours automatically.`)
};

const id_tut_presence_s3 = /** @type {(inputs: Tut_Presence_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka **Pengaturan…** untuk menentukan hari dan jam kerja Anda serta zona waktu — WIB, WITA, atau WIT. Di luar jam itu, status Anda otomatis terbaca sebagai di luar jam kerja.`)
};

/**
* | output |
* | --- |
* | "Open **Pengaturan…** to set your working days and hours and your timezone — WIB, WITA, or WIT. Outside those hours your status reads as off-hours automatically." |
*
* @param {Tut_Presence_S3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_presence_s3 = /** @type {((inputs?: Tut_Presence_S3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Presence_S3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_presence_s3(inputs)
	return en_tut_presence_s3(inputs)
});